import { pesRouterNavigationType } from '@pes-ui/utils';
import { createStore } from '@stencil/store';
export const store = createStore({
  navigation: pesRouterNavigationType.EVENT,
  bypass: false,
  usePesRouter: false,
  enableAppRouting: false,
  showCustomPrice: false,
});
